module.exports = __webpack_public_path__ + "static/media/vegetarian.fc674760.svg";